import { Link, useLocation, useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../utils/motion';
import { Hire, industries, services, Content, company } from "./HeaderData";


const HeaderOptions = ({ setisHover, title }) => {


    let unactiveClass = 'flex items-center gap-2 p-2 rounded-md hover:shadow-md cursor-pointer duration-700 dark:text-white dark:hover:bg-gray-600'
    let activeClass = 'flex items-center gap-2 p-2 rounded-md hover:shadow-md cursor-pointer duration-700 text-white bg-gradient-to-r from-red-600 to-red-500 '

    const location = useLocation()
    const navigate = useNavigate()

    let x = location.pathname
    let locationName = x.split('/')[1]

    let data

    if (title === 'Services') {
        data = services
    }
    else if (title === 'Industries') {
        data = industries
    }
    else if (title === 'Hire developers') {
        data = Hire
    }
    else if (title === 'Content Hub') {
        data = Content
    }
    else if (title === 'Company') {
        data = company
    }



    return (
        <div className='absolute top-10 left-[18%] right-[18%] z-40'
            onMouseEnter={() => setisHover(title)}
            onMouseLeave={() => setisHover('')}
        >

            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.25 }}>

                <motion.div
                    variants={fadeIn('up', 'tween', 0, 0.7)}
                >
                    <div className='bg-white dark:bg-gray-800 mx-auto rounded-md p-3 shadow-md'>
                        <motion.div
                            whileInView={{ opacity: [0, 1] }}
                            transition={{ duration: 1.2 }}
                        >
                            <div className='grid grid-cols-3 gap-3 w-full'>
                                {data.map((item, i) => {

                                    let route = item.title.replace(/ /g, "-")
                                    let routeLocation
                                    let x
                                    if (item.title === 'ui/ux design') {
                                        x = 'UI/UX Design'
                                        routeLocation = 'ui-ux-design'
                                    }
                                    else if(item.title === 'hire sqa engineers'){
                                        x = 'Hire SQA Engineers'
                                    }
                                    else if (item.title === 'e books') {
                                        routeLocation = 'ebook-cover-making'
                                    }
                                    return <Link
                                        to={routeLocation ? routeLocation : route}
                                        key={i}
                                        className={locationName === route || locationName === routeLocation ? activeClass : unactiveClass}
                                        onClick={() => setisHover('')}
                                    >
                                        <div>
                                            <img src={item.icon} alt='icon' className='h-6 ' />
                                        </div>
                                        <h3 className='text-[15px] capitalize '>{x ? x : item.title}</h3>
                                    </Link>
                                })}

                            </div>

                        </motion.div>
                    </div>
                </motion.div>
            </motion.div>
        </div >
    )
}

export default HeaderOptions